application.register("part-map", class extends Stimulus.Controller {
    connect() {
        let map_inner = this.element.querySelector("#map");

        importScript("https://maps.googleapis.com/maps/api/js?key=AIzaSyCqgRX0uc3dRbDDjq38EIt5IzR3dgCWUFc",()=>{
            let coords = map_inner.dataset.coords.split(/[\s,]+/);

            let mapOptions = {
                zoom: 17, scrollwheel: false, draggable: false, mapTypeControl: false, disableDefaultUI: true, center: {
                    lat: parseFloat(coords[0]), lng: parseFloat(coords[1])
                }
            };

            let map = new google.maps.Map(map_inner, mapOptions);

            let image = new google.maps.MarkerImage(
                "../img/marker.png",
                null,
                null,
                null,
                new google.maps.Size(60, 90)
            );

            let marker = new google.maps.Marker({
                title: map_inner.dataset.title,
                icon: image,
                position: mapOptions.center,
                url: map_inner.dataset.url
            });

            marker.setMap(map);

            function loadURL(marker) {
                return function () {
                    window.open(marker.url);
                }
            }

            google.maps.event.addListener(marker, 'click', loadURL(marker));

            google.maps.event.addListener(map, 'click', function () {
                map.setOptions({
                    scrollwheel: true, draggable: true
                });
            });
        });
    }
});